import { deviceType } from './constants';

const backIconHtml = `<svg class="icons icon-back">
  <use xlink:href="#icon-back"></use>
</svg>`;

const forwardIconHtml = `<svg class="icons icon-forward">
  <use xlink:href="#icon-forward"></use>
</svg>`;

const defaultResponsiveConfig = {
  0: {
    items: 2,
  },
  // follow the same responsive breakpoint as product list
  767: {
    items: 4,
  },
};

export const deviceItemConfig = {
  [deviceType.MOBILE]: 2,
  [deviceType.DESKTOP]: 4,
};

export function checkIsInitializedOwlCarousel(selector) {
  return !!$(`${selector} .owl-carousel`).data('owl.carousel');
}

export function initializeOwlCarousel({
  selector,
  isLoop,
  carouselItems = [],
  onDragStateChange = () => {},
} = {}) {
  const parent = document.querySelector(selector);
  if (!parent || carouselItems.length === 0) return;

  wrapElementWithOwlElement({ selector, carouselItems });

  $(`${selector} .owl-carousel`).owlCarousel({
    margin: 16,
    navText: '',
    navElement: 'div',
    nav: true,
    dots: false,
    loop: !!isLoop,
    onInitialized: function () {
      updateButtonPosition(selector);

      const $owlNav = $(`${selector} .owl-nav`);
      // Replace icons instead of appending to prevent duplication
      $owlNav.find('.owl-prev').html(backIconHtml).addClass('owl-btn-custom');
      $owlNav
        .find('.owl-next')
        .html(forwardIconHtml)
        .addClass('owl-btn-custom');
    },
    onResized: function () {
      updateButtonPosition(selector);
    },
    onTranslate: function () {
      onDragStateChange(true);
    },
    onTranslated: function () {
      onDragStateChange(false);
    },
    responsive: defaultResponsiveConfig,
  });
}

// Helper to wrap unwrapped elements into OwlCarousel wrapper
// i.e: <div class="owl-carousel owl-theme">...</div>
export function wrapElementWithOwlElement({ selector, carouselItems }) {
  const targetNode = document.querySelector(selector);
  const parent = document.createElement('div');
  parent.classList.add('owl-carousel', 'owl-theme');

  carouselItems.forEach((node) => {
    parent.appendChild(node); // move node into wrapper
  });

  targetNode.appendChild(parent);
}

export function destroyOwlCarousel(selector) {
  const $carousel = $(`${selector} .owl-carousel`);
  if ($carousel.data('owl.carousel')) {
    $carousel.owlCarousel('destroy');
    // move children out of the carousel wrapper and remove the wrapper
    unwrapOwlElement(selector);
  }
}

export function unwrapOwlElement(selector) {
  const carousel = document.querySelector(`${selector} .owl-carousel`);
  const parent = carousel?.parentElement;
  if (!carousel || !parent) return;
  const children = Array.from(carousel.children);
  children.forEach((child) => {
    parent.appendChild(child);
  });
  parent.removeChild(carousel);
}

export function updateButtonPosition(selector) {
  const $owlNav = $(`${selector} .owl-nav`);
  if ($owlNav.length) {
    const imageHeight =
      $(`${selector} .boxify-image-wrapper`).outerHeight() ||
      $(`${selector} .js-boxify-image`).outerHeight() ||
      $(`${selector} .Image-boxify-image`).outerHeight();
    const imageTopOffset =
      $(`${selector} .boxify-image-wrapper`).offset()?.top ||
      $(`${selector} .js-boxify-image`).offset()?.top ||
      $(`${selector} .Image-boxify-image`).offset()?.top;

    // get the top offset of the first owl item
    const owlItemTopOffset = $(`${selector} .owl-item`).offset()?.top;

    if (imageHeight && owlItemTopOffset && imageTopOffset) {
      const verticalOffsetBetweenElements = imageTopOffset - owlItemTopOffset;
      const imageCenterPosition =
        imageHeight / 2 + verticalOffsetBetweenElements;

      $owlNav.css('transform', `translateY(${imageCenterPosition}px)`);
    }
  }
}
